import { mergeDataSchema } from '@tencent/data-schema-core';
import { fromJsonData } from '@tencent/data-schema-core/lib/convertor/jsonData';
/**
 * 页面变量，在存在示例值 + 默认值时，生成 schema 应该综合两者一起求并集
 */
export function generateDataSchemaFromValues(...values) {
  let schema = {
    type: 'any'
  };
  for (let i = 0; i < values.length; i++) {
    const value = values[i];
    if (value == null) continue; // eslint-disable-line eqeqeq
    const mSchema = fromJsonData(value);
    schema = mergeDataSchema(schema, mSchema);
  }
  return schema;
}
//# sourceMappingURL=generateDataSchemaFromValues.js.map
